import type { ReactNode, ElementType } from 'react';

interface SectionProps {
  id: string;
  title: string;
  Icon?: ElementType;
  children: ReactNode;
  className?: string;
}

export default function Section({ id, title, Icon, children, className = '' }: SectionProps) {
  return (
    <section id={id} className={`portfolio-section px-6 ${className}`}>
      <header className="max-w-5xl mx-auto">
        <h2 className="inline-flex items-center gap-2">
          {Icon && <Icon size={28} weight="bold" aria-hidden="true" />}
          {title}
        </h2>
      </header>
      <div className="max-w-5xl mx-auto">
        {children}
      </div>
    </section>
  );
}
